import React from "react";
import { ModalBase } from "../../ModalBase";

import { TypeKey } from "./EquivalentCard";
import { getInfoCopy } from "../utils/get-info-copy";

type Props = {
  close: () => void;
  typeKey: TypeKey | null;
};

export const InfoModal: React.FC<Props> = (props) => {
  const { close, typeKey } = props;
  const copy = typeKey ? getInfoCopy(typeKey) : "";

  return (
    <ModalBase
      isOpen={!!typeKey}
      onClose={close}
      title="Additional information"
    >
      {copy}
    </ModalBase>
  );
};
